<!-- <template>
    <v-container color="primary">
        <v-row>
            <v-col class="d-flex justify-center">
                <v-sheet color="background">
                    <header>
                        <v-row justify-md="center" wrap>
                            <span class="text-h3 text-uppercase d-flex text-center" style="color: #ffc107">{{ title
                                }}</span>
                        </v-row>
                    </header>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <MaterialfyWalletsTable />
            </v-col>
        </v-row>
    </v-container>
</template> -->

<template>
    <v-container color="primary">
        <v-row justify-md="center" wrap>
            <v-col cols="1" xs="0" sm="0" md="1">
            </v-col>
            <v-col cols="10" xs="12" sm="12" md="10">
                <materialfy-header-card cardTitle='WALLETS' text="Here is a subtitle for this table" cardMinWidth="250"
                    :cardShowInnerList="false" :cardShowDivider="false" :cardShowActions="false">
                    <template v-slot:crdInner>
                        <br>
                        <v-row wrap>
                            <v-col cols="3" xs="0" sm="0" md="3" class="flex-grow-0 flex-shrink-0"></v-col>
                            <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                <v-select v-model="exchange" :items="itemsExchange" item-text="exchange" item-value="id"
                                    label="Select Exchange" @change="onChange($event)" persistent-hint return-object
                                    single-line></v-select>
                            </v-col>
                        </v-row>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <MaterialfyDataTables ref="dataTable" cardTitle="API" :showSearch="false" :actions="actions"
                            :hasActions="false" @action-clicked="handleActionClicked" :showCardTitle="false" />
                        <br>
                    </template>
                    <template #crdActions>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <v-row no-gutters justify="center">
                            <v-btn color="tertiary" @click="menuActionClick('openDialogBot')" class="mb-2"> NUEVA API
                            </v-btn>
                        </v-row>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                    </template>
                </materialfy-header-card>
                <!-- <v-snackbar v-model="snackbar" :color="color" :bottom="bottom" :top="top" :float-left="left"
                    :float-right="right">
                    <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
                    <div>
                        {{ msg_toast }}
                    </div>
                    <v-icon size="16" @click="snackbar = false">
                        mdi-close-circle
                    </v-icon>
                </v-snackbar> -->
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserService from '@/services/user.service'

export default {
    name: "WalletsView",
    data: () => ({
        title: 'WALLETS',
        // Table
        headers: [
            { text: "Divisa", value: "currency", align: "center" },
            { text: "Disponible", value: "available", align: "center" },
            { text: "Congelado", value: "frozen", align: "center" },
            { text: "Total", value: "total", align: "center" },
            { text: "Retirando", value: "withdrawing", align: "center" }
        ],
        itemsExchange: [],
        exchange: '',
        items: [],
        actions: [ ],

    }),
    mounted() {
        UserService.getClients().then(
            response => {
                if (response.data !== '') {
                    // console.log(response.data)
                    // this.desserts = response.data;
                    for (let i = 0; i < response.data.length; i++) {
                        let aux = { 'id': response.data[i]['id'], 'exchange': response.data[i]['exchange']['exchange'] }
                        this.itemsExchange.push(aux);

                        this.$refs.dataTable.headers = this.headers
                        // this.$refs.dataTable.items = this.items
                    }
                }
            },
            error => {
                this.content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                if (error.response && error.response.status === 403 || error.response.status === 401) {
                    this.$store
                        .dispatch('logout', this.user) //calls the login action and passes login info
                        .then(() => this.$router.push('/')) //redirect to dash after login
                        .catch((err) => {
                            console.log(err)
                            this.snackbar = true //shows error on wrong pass
                        })
                }
            }
        );
    },

    methods: {
        handleActionClicked({ item, action }) {
            console.log('Action clicked in parent:', action);
            console.log('Item:', item);
            // Aquí puedes manejar la lógica en el componente padre
        },
        onChange(exchange) {
            this.items = []
            // console.log(exchange.id)
            UserService.getWallets(exchange.id).then(
                response => {
                    // console.log(response)
                    this.loadData(response);
                },
                error => {
                    this.content =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    setTimeout(() => (this.responseWallet('error', error.response.data)), 2000)
                }
            );
        },
        loadData(data) {
            this.items = data
            this.$refs.dataTable.items = this.items
        },
    },
};
</script>

<style></style>
